<template>
  <div class="search-module">
    <!-- Filtro Data Da e A -->
    <div class="filter-group">
      <label for="startDate">Data Da:</label>
      <input type="date" v-model="selectedFilters.startDate" id="startDate" class="filter-input-date" />

      <label for="endDate">Data A:</label>
      <input type="date" v-model="selectedFilters.endDate" id="endDate" class="filter-input-date" />
    </div>

    <!-- Filtro Data Consegna Da e A -->
    <div class="filter-group">
      <label for="deliveryStartDate">Data Consegna Da:</label>
      <input type="date" v-model="selectedFilters.deliveryStartDate" id="deliveryStartDate" class="filter-input-date" />

      <label for="deliveryEndDate">Data Consegna A:</label>
      <input type="date" v-model="selectedFilters.deliveryEndDate" id="deliveryEndDate" class="filter-input-date" />
    </div>

    <!-- Filtro Email -->
    <div class="filter-group">
      <label for="emailFilter">Ricerca Utente:</label>
      <input
        v-model="selectedFilters.email"
        type="text"
        id="emailFilter"
        class="filter-input"
        placeholder="Inserisci email"
      />
    </div>

    <!-- Filtro Assigned Email -->
    <div class="filter-group">
      <label for="assignedEmailFilter">Ricerca Assegnazione:</label>
      <input
        v-model="selectedFilters.assignedEmail"
        type="text"
        id="assignedEmailFilter"
        class="filter-input"
        placeholder="Inserisci assignedEmail"
      />
    </div>

    <!-- Filtro Studio -->
    <div class="filter-group" ref="dropdownContainer">
      <label for="selectedStudio">Studio:</label>
      <div class="custom-select" @click="toggleDropdown">
        {{ selectedFilters.studio.length ? selectedFilters.studio.join(', ') : 'Seleziona uno studio' }}
        <span class="arrow">&#9660;</span>
      </div>
      <div v-if="dropdownOpen" class="checkbox-dropdown">
        <div v-for="option in studioOptions" :key="option" class="checkbox-item">
          <input
            type="checkbox"
            :id="option"
            :value="option"
            v-model="selectedFilters.studio"
          />
          <label :for="option">{{ option }}</label>
        </div>
      </div>
    </div>

    <!-- Azioni Filtro -->
    <div class="filter-actions">
      <button @click="applyFilters" class="filter-button">Cerca</button>
      <button @click="resetFilters" class="filter-button reset">Reset</button>
      <button @click="scrollToBottom" class="filter-button fine">Fine tabella</button>
      <button @click="scrollToTop" class="filter-button fine">Inizio tabella</button>
    </div>

    <!--
    <div class="filter-actions">
      <button @click="exportToCSVTrainer" class="filter-button">Esporta CSV Trainer</button>
    </div>
    -->
  </div>
</template>

<script>
export default {
  props: {
    userData: {
      type: Array,
      required: true
    }
  },
  data() {
    const today = new Date().toISOString().split("T")[0];
    const threeDaysLater = new Date();
    threeDaysLater.setDate(threeDaysLater.getDate() + 5);
    const threeDaysLaterFormatted = threeDaysLater.toISOString().split("T")[0];

    return {
      dropdownOpen: false,
      studioOptions: [
        "Tivoli Quartier generale",
        "FF Genova",
        "FF Bologna",
        "FF Bari",
        "FF Pescara",
        "FF Firenze",
        "FF Torino",
        "FF Napoli",
        "FF Milano",
        "FF Roma",
        "FF Salerno",
        "FF Cagliari",
        "FF Milano Citta Studi",
        "FF Roma Eur",
        "FF Milano Sempione",
        "FF Padova"
      ],
      selectedFilters: {
        studio: [],
        startDate: "",
        endDate: "",
        deliveryStartDate: today,
        deliveryEndDate: threeDaysLaterFormatted,
        email: "",
        assignedEmail: ""
      },
      filteredUserData: []
    };
  },
  mounted() {
    this.applyFilters();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownContainer;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
    applyFilters() {
      let filteredData = [...this.userData];
      // Filtro Data Consegna
      if (this.selectedFilters.deliveryStartDate && this.selectedFilters.deliveryEndDate) {
        const start = new Date(this.selectedFilters.deliveryStartDate).getTime();
        const end = new Date(this.selectedFilters.deliveryEndDate).getTime() + 24 * 3600 * 1000 - 1;
        filteredData = filteredData.filter(user => {
          if (!user.dataConsegna) return false;
          const ts = user.dataConsegna.toDate
            ? user.dataConsegna.toDate().getTime()
            : new Date(user.dataConsegna).getTime();
          return ts >= start && ts <= end;
        });
      }
      // Filtro Studio
      if (this.selectedFilters.studio.length) {
        filteredData = filteredData.filter(user => this.selectedFilters.studio.includes(user.studio));
      }
      // Filtro Data Creazione
      if (this.selectedFilters.startDate && this.selectedFilters.endDate) {
        const s = new Date(this.selectedFilters.startDate).getTime();
        const e = new Date(this.selectedFilters.endDate).getTime() + 24 * 3600 * 1000 - 1;
        filteredData = filteredData.filter(user => {
          const c = user.createdAt.toDate
            ? user.createdAt.toDate().getTime()
            : new Date(user.createdAt).getTime();
          return c >= s && c <= e;
        });
      }
      // Filtro Email
      if (this.selectedFilters.email) {
        filteredData = filteredData.filter(user =>
          user.email.toLowerCase().includes(this.selectedFilters.email.toLowerCase())
        );
      }
      // Filtro Assigned Email
      if (this.selectedFilters.assignedEmail) {
        filteredData = filteredData.filter(user =>
          user.assignedEmail && user.assignedEmail.toLowerCase().includes(this.selectedFilters.assignedEmail.toLowerCase())
        );
      }
      this.filteredUserData = filteredData;
      this.$emit("filtered-data", this.filteredUserData);
    },
    resetFilters() {
      const today = new Date().toISOString().split("T")[0];
      const threeDaysLater = new Date();
      threeDaysLater.setDate(new Date().getDate() + 3);
      const threeLater = threeDaysLater.toISOString().split("T")[0];
      this.selectedFilters = {
        studio: [],
        startDate: "",
        endDate: "",
        deliveryStartDate: today,
        deliveryEndDate: threeLater,
        email: "",
        assignedEmail: ""
      };
      this.applyFilters();
    },
    scrollToBottom() {
      const table = document.querySelector("table");
      if (table) table.scrollIntoView({ behavior: "smooth", block: "end" });
    },
    scrollToTop() {
      const table = document.querySelector("table");
      if (table) table.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    async exportToCSVTrainer() {
      try {
        if (!this.filteredUserData.length) {
          alert("Nessun dato filtrato disponibile per l'esportazione.");
          return;
        }
        let csv = "data:text/csv;charset=utf-8,";
        const headers = ["Data", "Studio", "Email", "Nome", "Cognome"];  
        csv += headers.join(";") + "\n";
        const clean = f => f ? `"${String(f).replace(/\n/g, ' ').replace(/;/g, ',')}"` : "";
        const fmtDate = ts => ts.toDate ? ts.toDate().toLocaleDateString("it-IT") : new Date(ts).toLocaleDateString("it-IT");
        this.filteredUserData.forEach(u => {
          const row = [
            u.dataConsegna ? fmtDate(u.dataConsegna) : "",
            u.studio,
            u.email,
            u.name,
            u.surname
          ].map(clean);
          csv += row.join(";") + "\n";
        });
        const uri = encodeURI(csv);
        const link = document.createElement("a");
        link.href = uri;
        link.download = "inviidigiornata_trainer.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alert("Esportazione completata!");
      } catch (err) {
        console.error(err);
        alert("Errore durante l'esportazione. Controlla i log.");
      }
    }
  }
};
</script>






<style scoped>
.filter-group #selectedStudio {
flex-grow: 1;
min-width: 200px; /* Larghezza minima */
}

.custom-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  width: 100%;
}

.arrow {
  margin-left: 10px;
  font-size: 12px;
  color: #555;
}

.checkbox-dropdown {
  position: absolute;
  background-color: #424242;
  border: 1px solid #616161;
  border-radius: 8px;
  padding: 10px;
  width: 223px;
  max-height: 223px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
}


.checkbox-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  height: 150px; /* Limita l'altezza */
  width: 100px;
  overflow-y: auto; /* Aggiunge lo scroll verticale */
}

.checkbox-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
}

.filter-input[multiple] {
  height: auto; /* Permette alla select di crescere in altezza */
  min-height: 100px; /* Altezza minima */
  padding: 10px;
  border: 1px solid #787878;
  border-radius: 8px;
  background-color: #3e3e3e;
  font-size: 14px;
  color: #333;
  overflow-y: auto; /* Aggiunge uno scroll verticale se necessario */
  outline: none;
}

.search-module {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #dddddd; /* Sfondo leggero per evidenziare il blocco */
  border-radius: 8px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  flex: 1; /* Per far adattare le dimensioni dei campi */
  margin-top: 10px
}

.filter-group label {
  font-weight: 600;
  margin-bottom: 5px;
  color: #f1f1f1;
  margin-top: 10px;
}

.filter-input-date {
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: #333;
  transition: border-color 0.3s ease;
  width: 147px;
  padding-left: 10px;
  margin-right: 0px;
}

.filter-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: #333;
  transition: border-color 0.3s ease;
}

.filter-input:focus {
  border-color: #4caf50; /* Verde in evidenza al focus */
  outline: none;
}

.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex: 1 1 100%; /* Forza nuova riga occupando tutta la larghezza */
}

.filter-button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #4caf50;
  color: white;
  transition: background-color 0.3s ease;
}

.filter-button.reset {
  background-color: #f44336;
}

.filter-button.fine {
  background-color: #7f7f7f;
}

.filter-button:hover {
  background-color: #45a049;
}

.filter-button.reset:hover {
  background-color: #e53935;
}

.filter-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Miglioramenti visivi per le Select */
.filter-input option {
  font-weight: normal;
  color: #333;
}

.color-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  background-color: #fff;
}

.color-select:focus {
  border-color: #4caf50;
}
</style>
